import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "./axiosInstance";
import AuthService from "./AuthService";

function resolveMediaUrl(value) {
  if (!value) return "";
  if (/^https?:\/\//.test(value)) return value;
  const apiBase = axiosInstance.defaults?.baseURL || "";
  const backendBase = apiBase.replace(/\/api\/?$/, "").replace(/\/$/, "");
  return value.startsWith("/") && backendBase ? `${backendBase}${value}` : value;
}

export default function MyProfilePage() {
  const [form,setForm]=useState(AuthService.getCurrentUser()||{});
  const [photo,setPhoto]=useState(null);
  const [saving,setSaving]=useState(false);
  useEffect(()=>{ axiosInstance.get("auth/me/").then(r=>setForm(r.data)).catch(()=>{}); },[]);
  const preview=useMemo(()=>photo?URL.createObjectURL(photo):resolveMediaUrl(form.profile_picture),[photo,form.profile_picture]);
  useEffect(()=>()=>{if(preview?.startsWith("blob:"))URL.revokeObjectURL(preview)},[preview]);
  const save=async(e)=>{
    e.preventDefault(); setSaving(true);
    try{
      const payload=new FormData();
      ["phone","alternative_phone","address","city","province","country"].forEach(k=>payload.append(k,form[k]||""));
      if(photo)payload.append("profile_picture",photo);
      const {data}=await axiosInstance.patch("auth/me/",payload,{headers:{"Content-Type":"multipart/form-data"}});
      const picture=resolveMediaUrl(data.profile_picture);
      const current=AuthService.updateCurrentUser({...data,profile_picture:picture,profile_picture_url:picture});
      setForm(current); setPhoto(null); toast.success("Profile updated.");
    }catch(err){toast.error(err.response?.data?.detail||"Failed to update profile.");}
    finally{setSaving(false);}
  };
  return <div className="container-fluid py-4">
    <div className="card border-0 shadow-sm"><div className="card-body">
      <h4 className="fw-bold mb-1">My Profile</h4><p className="text-muted">Keep your administrator photograph and contact details current.</p>
      <form className="row g-4" onSubmit={save}>
        <div className="col-lg-3 text-center">
          {preview?<img src={preview} alt="Profile" className="rounded-circle border mb-3" style={{width:160,height:160,objectFit:"cover"}}/>:<div className="rounded-circle border bg-light d-inline-flex align-items-center justify-content-center mb-3" style={{width:160,height:160}}><i className="bi bi-person fs-1 text-muted"/></div>}
          <label className="btn btn-outline-success w-100"><i className="bi bi-camera me-2"/>Change Profile Picture<input type="file" accept="image/*" className="d-none" onChange={e=>setPhoto(e.target.files?.[0]||null)}/></label>
        </div>
        <div className="col-lg-9"><div className="row g-3">
          <Field label="Full Name" value={form.full_name} disabled/><Field label="Email" value={form.email} disabled/>
          {["phone","alternative_phone","city","province","country"].map(k=><Field key={k} label={k.replaceAll("_"," ").replace(/\b\w/g,c=>c.toUpperCase())} value={form[k]} onChange={v=>setForm({...form,[k]:v})}/>)}
          <div className="col-12"><label className="form-label fw-semibold">Address</label><textarea className="form-control" rows="3" value={form.address||""} onChange={e=>setForm({...form,address:e.target.value})}/></div>
          <div className="col-12"><button className="btn btn-success px-4" disabled={saving}>{saving?"Saving...":"Save Profile"}</button></div>
        </div></div>
      </form>
    </div></div>
  </div>;
}
function Field({label,value,onChange=()=>{},disabled=false}){return <div className="col-md-6"><label className="form-label fw-semibold">{label}</label><input className="form-control" value={value||""} disabled={disabled} onChange={e=>onChange(e.target.value)}/></div>}
